import React from "react";

export default props => (
  <footer>
    <div id="footer-content">
      <div id="footer-main">
        <div className="footer-column">
          <div id="footer-text">
            <h1>Lucyna Talejko-Kwiatkowska</h1>
            <h2>
              <span className="label">Illustrator</span>
              <span className="label">Graphic Designer</span>
              <span className="label">Lecturer</span>
            </h2>
            <h3>
              Get in touch:
            </h3>
            <a id="contact" href="&#109;&#97;&#105;&#108;&#116;&#111;&#58;&#99;&#111;&#110;&#116;&#97;&#99;&#116;&#64;&#108;&#117;&#99;&#121;&#110;&#97;&#116;&#97;&#108;&#101;&#106;&#107;&#111;&#46;&#107;&#119;&#105;&#97;&#116;&#107;&#111;&#119;&#115;&#99;&#121;&#46;&#101;&#117;">
              &#99;&#111;&#110;&#116;&#97;&#99;&#116;&#64;&#108;&#117;&#99;&#121;&#110;&#97;&#116;&#97;&#108;&#101;&#106;&#107;&#111;&#46;&#107;&#119;&#105;&#97;&#116;&#107;&#111;&#119;&#115;&#99;&#121;&#46;&#101;&#117;
            </a>
          </div>
        </div>
        <div className="footer-column" id="explore-panel">
          <p>explore more</p>
          <div className="link"><a href="/#covers">Book covers</a></div>
          <div className="link"><a href="/#illustrations">Illustrations</a></div>
          <div className="link"><a href="/#infographics">Information design</a></div>
        </div>
      </div>
      <div id="footer-footer">
        <div id="designed">
          designed by: <a href="https://www.instagram.com/awkwiatski/" target="_blank" rel="noreferrer">@awkwiatski</a>
        </div>
        <div id="copyright">
          Copyright © 2021 Lucyna Telejko-Kwiatkowska
        </div>
      </div>
    </div>
  </footer>
);
